import CreateButton from './Button/Create'

// default component views
import ModelEdit from '@/components/base/Edit'
import ModelCreate from '@/components/base/Create'
import BaseWidget from '@/components/widgets/Base'
import CodeEditor from "@/components/form/Editor/Code"
import QRCode from 'qrcode.vue'
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader'

// ui components
import VSelect from 'vue-select'
import Field from './Field'
import Draggable from 'vuedraggable'

// media ui
import MediaLibrary from '@/components/integrations/protokol/media/Index'
import ComponentView from '../base/ComponentView'
import AppView from '@/views/apps/AppView'

export default {
    CreateButton,
    ModelEdit,
    ModelCreate,
    VSelect,
    BaseWidget,
    MediaLibrary,
    Field,
    Draggable,
    CodeEditor,
    QRCode,
    QRCodeStream: QrcodeStream,
    QRCodeDropZone: QrcodeDropZone,
    QRCodeCapture: QrcodeCapture,
    ComponentView,
    AppView
}